"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchWrapper = fetchWrapper;
const baseUrls_1 = require("./baseUrls");
function handleResponse(response) {
    if (!response.ok) {
        const error = { status: response.status, statusText: response.statusText, errorCause: '' };
        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType.indexOf('application/json') > -1) {
            return response.json().then((json) => {
                error.errorCause = json.errorCause;
                return Promise.reject(error);
            });
        }
        // return response.text().then((text) => (console.log({text})));
        return Promise.reject(error);
    }
    try {
        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType.indexOf('application/json') > -1) {
            return response.json().then((json) => ({ data: json, headers: response.headers }));
        }
        return response.text().then((text) => ({ data: text, headers: response.headers }));
    }
    catch {
        return Promise.reject(new Error('Could not parse the response'));
    }
}
function fetchWrapper(path, options) {
    const { method, headers, query, signal } = options;
    const reqOptions = { method, headers };
    if (signal) {
        reqOptions.signal = signal;
    }
    if (method === 'POST' || method === 'PATCH' || method === 'PUT') {
        const { body } = options;
        if (body instanceof FormData) {
            reqOptions.body = body;
        }
        else if (typeof body === 'object') {
            reqOptions.body = JSON.stringify(body);
            reqOptions.headers = {
                ...reqOptions.headers,
                'Content-Type': 'application/json',
            };
        }
    }
    if (baseUrls_1.clientOrigin) {
        reqOptions.headers = {
            ...reqOptions.headers,
            Origin: baseUrls_1.clientOrigin
        };
    }
    const queryParams = query ? new URLSearchParams(query).toString() : '';
    return fetch(`${path}${queryParams ? `?${queryParams}` : ''}`, reqOptions).then((response) => handleResponse(response));
}
